/** Typed access to Vite env (only VITE_-prefixed vars reach the browser). */

export function getApiBaseUrl(): string {
  return (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || '';
}

export function getOktaIssuer(): string {
  return (import.meta.env.VITE_OKTA_ISSUER as string | undefined)?.trim() || '';
}

export function getOktaClientId(): string {
  return (import.meta.env.VITE_OKTA_CLIENT_ID as string | undefined)?.trim() || '';
}

export function getOktaRedirectUri(): string {
  return (import.meta.env.VITE_OKTA_REDIRECT_URI as string | undefined)?.trim() || '';
}
